var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47014 1.46967C7.76303 1.17678 8.2379 1.17678 8.5308 1.46967L13.3038 6.24264C13.5967 6.53553 13.5967 7.01041 13.3038 7.3033C13.0109 7.59619 12.536 7.59619 12.2431 7.3033L8.75047 3.81066L8.75047 14C8.75047 14.4142 8.41468 14.75 8.00047 14.75C7.58625 14.75 7.25047 14.4142 7.25047 14L7.25047 3.81066L3.75783 7.3033C3.46493 7.59619 2.99006 7.59619 2.69717 7.3033C2.40427 7.01041 2.40427 6.53553 2.69717 6.24264L7.47014 1.46967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescending);
export default __webpack_public_path__ + "static/media/SortDescending.b28dc8f8f13ada123919fd76f4e90a58.svg";
export { ForwardRef as ReactComponent };